export default __webpack_public_path__ + "static/layout_cloud_topLeft-a1a3c6ba8ba67a8c402dc1110c5d352a.webp";